import { Component, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { first } from 'rxjs/operators';
import { UploadTestTimingService } from '../../shared/services/upload-test-timing/upload-test-timing.service';
import { Router } from '@angular/router';
import { AlertService } from '../../shared/services/alert/alert.service';


@Component({
  selector: 'app-upload-test-timing',
  templateUrl: './upload-test-timing.component.html',
  styleUrls: ['./upload-test-timing.component.scss']
})
export class UploadTestTimingComponent implements OnInit {


  fileType: any = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
  dataAvailable = false;
  dataCount: any;
  uploadType: any = "import";
  error: any;
  private _error = new Subject<string>();
  errorMessage = null;
  successMessage = null;
  uploadtesttimingdata: any;
  sender = "upload-test-timing";
  errorOnly = false;
  errorCount = 0;
  showAll = true;

  constructor(
    private router: Router,
    private uploadTestTimingService: UploadTestTimingService,
    private alertService: AlertService
  ) { }

  ngOnInit() {
  }

  ondocImport(e) {

    this.uploadtesttimingdata = e;
    this.errorCount = 0

    for (var i = 0; i < this.uploadtesttimingdata.length; i++) {
      if (this.uploadtesttimingdata[i].errors.length > 0) {
        this.errorCount += 1;
        this.alertService.err(this.sender, this.uploadtesttimingdata[i].errors);
      }
    }

    if (this.uploadtesttimingdata.length > 0) {
      this.dataAvailable = true;
      this.dataCount = this.uploadtesttimingdata.length;
    }
    else {
      this._error.next("Data not found!!");
    }
  }

  getData() {

    var data = [];

    if (!this.uploadtesttimingdata) {
      return data;
    }


    if (this.showAll) {
      return this.uploadtesttimingdata;
    }
    for (var i = 0; i < this.uploadtesttimingdata.length; i++) {
      var d = this.uploadtesttimingdata[i];
      if (this.errorOnly && d.errors.length > 0) {
        data.push(d);
      } else if (!this.errorOnly && d.errors.length == 0) {
        data.push(d);
      }
    }

    return data;
  }

  onConfirm() {

    if (this.errorCount > 0) {
            //this.error = "Fix all errors and try again";

      this.alertService.err(this.sender, "Fix all errors and try again");
      return;
    }

    this.uploadTestTimingService.saveTestTiming(this.uploadtesttimingdata)
      .pipe(first())
      .subscribe(res => {
        this.dataAvailable = false;
        if (res["status"] == "error") {
          //this.confirmerror = true;
          this.alertService.err(this.sender, res["message"]);
          return;
        }
        this.alertService.show(this.sender, "File uploaded successfully");
        setTimeout(() => {
          this.router.navigate(['timing']);
        }, 1000);

      });
  }

  ondocError(e) {
    this.error = e;
  }


}
